<div class="background">
  <div class="desktop-background">
    <div class="header">
      {{ 'money.depositHeader' | translate }}
    </div>
    <div class="description">
      {{ 'money.depositEditDescription' | translate }}
    </div>
  </div>

  <div class="form-container-layout">

    <div class="form-container">
        <div class="row">
          <div class="col-12 col-lg-4 offset-lg-4 order-lg-1">
            <div class="filtration-label">
              {{ 'strategies.name' | translate }}
            </div>
            <libero-text-input
              [formName]="editForm.controls['name']"
              placeholder="{{editForm.controls['name'].value}}"
            ></libero-text-input>
          </div>

          <div class="col-lg-4 order-lg-2"></div>

          <div class="col-12 col-lg-4 order-lg-3">
            <div class="filtration-label">
              {{ 'newPortfolio.filters.oneTimeDeposit' | translate }}
            </div>
            <libero-plus-minus-input
              [formName]="editForm.controls['initialDeposit']"
              [options]="{
                step: 500,
                displayUnits: getCurrencyFromCode(userService.loggedUser!.currencyCode),
                minValue: configService.getConfig(EnvironmentKeys.minimalInvest),
                maxValue: configService.getConfig(EnvironmentKeys.maximalInitialInvest),
                allowZero: configService.getConfig(EnvironmentKeys.allowZeroInitialDeposit)
              }"
              [digitShortcutsOptions]="digitShortcutsOptions"
              [invalidClass]="bothInvestmentsZero"
            ></libero-plus-minus-input>
          </div>

          <div class="col-12 col-lg-4 order-lg-5">
            <div class="filtration-label">
              {{ 'newPortfolio.filters.regularDeposit' | translate }}
            </div>
            <libero-plus-minus-input
              [formName]="editForm.controls['regularDeposit']"
              [options]="{
                step: 500,
                displayUnits: getCurrencyFromCode(userService.loggedUser!.currencyCode),
                minValue: configService.getConfig(EnvironmentKeys.minimalInvest),
                maxValue: configService.getConfig(EnvironmentKeys.maximalRegularInvest),
                allowZero: configService.getConfig(EnvironmentKeys.allowZeroRegularDeposit)
              }"
              [digitShortcutsOptions]="digitShortcutsOptions"
              [invalidClass]="bothInvestmentsZero"
            ></libero-plus-minus-input>
            <div class="regularity-radios-container">
              <libero-radio-input-group
                [availableValues]="availableInvestmentPeriods"
                [formName]="editForm.controls['depositRegularity']"
              ></libero-radio-input-group>
            </div>
          </div>

          <div class="col-12 col-lg-4 order-lg-4">
            <div class="filtration-label">
              {{ 'newPortfolio.filters.timeOfInvestment' | translate }}

              <libero-tooltip-button [explainPerson]="'jiri_mikes'">
                {{ 'global.tooltips.timeOfInvestment' | translate }}
              </libero-tooltip-button>
            </div>
            <!-- fixme - displayUnits -->
            <libero-plus-minus-input
              [formName]="editForm.controls['totalYearsToInvest']"
              [options]="{ step: 1, minValue: 1, maxValue: 30, sliderStartAtLowestStep: true }"
              [digitShortcutsOptions]="yearsShortcutsOptions"
            ></libero-plus-minus-input>
          </div>
        </div>

        <div class="save-button-container">
          <libero-button
            label="{{ 'global.continue' | translate }}"
            btnClasses="btn--primary btn--heading"
            (click)="openModal()"
          ></libero-button>

          <div class="back-link" routerLink="/money/deposit">
            {{ 'money.backButtonLabel' | translate }}
          </div>
        </div>
    </div>
  </div>
</div>